module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Seltisberg-931ed2a1fd92ce2dd43a660445168ecb.svg";